import { SvgProps } from "./types";

export const NumberedList = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 4H13.5M6.5 8H13.5M6.5 12H13.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M2.5 3.2L3.5 2.5V5.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.4 10.3C2.6 9.8 3 9.5 3.5 9.5C4.1 9.5 4.5 9.9 4.5 10.4C4.5 11.2 2.5 12.2 2.5 13.5H4.6"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
